import { render, staticRenderFns } from "./Jewel05_Nico.vue?vue&type=template&id=3d2a3dbe&scoped=true&"
import script from "./Jewel05_Nico.vue?vue&type=script&lang=js&"
export * from "./Jewel05_Nico.vue?vue&type=script&lang=js&"
import style0 from "./Jewel05_Nico.vue?vue&type=style&index=0&id=3d2a3dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2a3dbe",
  null
  
)

export default component.exports